@let selectedCountry = this.selectedCountry();
<warema-input-field>
    <warema-field-label [text]="'COUNTRY_SELECTION.LABEL' | translate" />
    <warema-dropdown
        id="country-select"
        [noSearchResultsText]="'NO_RESULTS_FOUND' | translate"
        [search]="true"
        [searchInputPlaceholder]="'SEARCH' | translate"
        [selectedLabel]="selectedCountry.label"
        [value]="selectedCountry.value"
        (change)="onCountrySelectionChange($any($event))"
    >
        @for (country of countries(); track country.value) {
            <warema-dropdown-option [label]="country.label" [value]="country.value" />
        }
    </warema-dropdown>
</warema-input-field>

<div class="action-buttons">
    <warema-button
        id="apply-country-selection"
        [text]="'COUNTRY_SELECTION.APPLY_SELECTION' | translate"
        (click)="popupResult$.next(selectedCountry)"
    />
    <warema-button
        id="cancel-country-selection"
        type="secondary"
        [text]="'COUNTRY_SELECTION.CANCEL_SELECTION' | translate"
        (click)="popupResult$.next(null)"
    />
</div>
